// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Xg60","content":"styles_content__2KkKC","row":"styles_row__3djj8","footer":"styles_footer__1xeF0","phraseLength":"styles_phraseLength__3KuKw"};